var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"rpl-accordion__list"},_vm._l((_vm.schemePDFMaps),function(accordion,index){return _c('Accordion',{key:index,attrs:{"accordion":accordion.maps,"gridReference":accordion.gridNumber}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }